import React, { useEffect, useRef, useState } from 'react';
import useGlobal from 'hooks/useGlobal';
import s from './instagram_embed.module.scss';

export default function EmbedPost({ link }) {
  const { dispatch, state } = useGlobal();
  const [active, setActive] = useState(true);
  useEffect(() => {
    if (!state.instaScript) {
      dispatch({
        type: 'update',
        payload: {
          instaScript: true
        }
      });
    }
    if (window?.instgrm?.Embeds?.process) {
      window.instgrm.Embeds.process();
    }
  }, [state]);
  return (
    <div className={s.root}>
      <div
        className={s.postWrapper}
        dangerouslySetInnerHTML={{
          __html: `
        <blockquote class="instagram-media" data-instgrm-captioned data-instgrm-version="12" data-instgrm-permalink="${link}">
</blockquote>
  `
        }}
      />
    </div>
  );
}

function FadeWrapper({ shouldShow, setHeight, children, className }) {
  const wrapperRef = useRef();
  const timeout = useRef();
  const [active, setActive] = useState(shouldShow);
  useEffect(() => {
    const resizeAuto = () => {
      setHeight('auto');
    };
    window.addEventListener('resize', resizeAuto);
    if (wrapperRef.current) {
      const { height } = wrapperRef.current.getBoundingClientRect();
      setHeight(height);
    }
    return () => window.removeEventListener('resize', resizeAuto);
  }, []);
  useEffect(() => {
    clearTimeout(timeout.current);
    if (shouldShow && !active) {
      timeout.current = setTimeout(() => {
        const { height } = wrapperRef.current.getBoundingClientRect();
        setHeight(height);
        setActive(true);
      }, 200);
    }
    if (active && !shouldShow) {
      timeout.current = setTimeout(() => {
        setActive(false);
      }, 500);
    }
  }, [shouldShow]);

  return (
    <div
      className={`${s.fadeWrapper} ${
        shouldShow && active ? s.shouldShow : ''
      } ${className || ''}`}
      ref={wrapperRef}
    >
      {children}
    </div>
  );
}
